import { useSyncExternalStore } from 'react';
import { subscribeOrgFormat, orgFormatVersion } from './orgFormat';

/**
 * Subscribe a component to org display-format changes (date format / week start).
 * The prefs are a module singleton updated by the boot fetch and the admin
 * Settings save; calling this makes the component re-render when they change, so
 * surfaces that render timestamps (bell popup, notifications page, Recent Activity)
 * reflect the configured format instead of the stale startup default. The returned
 * version is incidental — subscribing for the re-render is the point.
 */
export function useOrgFormat(): number {
  return useSyncExternalStore(subscribeOrgFormat, orgFormatVersion, orgFormatVersion);
}
